import { TemplateResult, html, nothing, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
// import { ScreenSizeController } from '../../../controllers/screen-size-controller';
import encapsulatedStyles from './outline-kyruus-facet-wrapper.inner.pcss?inline';
import globalStyles from './outline-kyruus-facet-wrapper.global.pcss?inline';
import { AdoptedStyleSheets } from '../../../controllers/adopted-stylesheets';
import '../../outline-icon/outline-icon';

/**
 * The Kyruus Facet Wrapper Component
 * @element outline-kyruus-facet-wrapper
 * @slot - Default slot to accept any number of checkbox components
 * @property {String} screenSize - The current screen size, can be 'mobile' or 'desktop'. Automagically set.
 * @property {Boolean} filtersVisible - A flag indicating whether the filters are currently visible. Automagically set.
 *
 * @dependency outline-cta
 * @dependency outline-icon
 *
 * @todo replace screen size controller with container query
 */
@customElement('outline-kyruus-facet-wrapper')
export class OutlineKyruusFacetWrapper extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });
  // screenSizeController = new ScreenSizeController(this);

  @property({ type: String, reflect: true }) screenSize: 'mobile' | 'desktop';
  @property({ type: Boolean, reflect: true }) filtersVisible = false;

  private toggleFilterVisibility(): void {
    this.filtersVisible = !this.filtersVisible;
  }

  render(): TemplateResult {
    // const mobileSizes = ['xxs', '2xs', 'xs', 'sm', 'md'];
    // this.screenSize = mobileSizes.includes(this.screenSizeController.screenSize)
    //   ? 'mobile'
    //   : 'desktop';

    const wrapperClasses = {
      'facet-wrapper': true,
      [this.screenSize]: true,
      'filters-visible': this.filtersVisible,
    };

    return html`
      ${this.filterButtonTemplate()}
      <div class="${classMap(wrapperClasses)}">
        <slot></slot>
      </div>
    `;
  }

  filterButtonTemplate() {
    if (this.screenSize !== 'mobile') {
      return nothing;
    }

    return html`
      <button
        class="outline-cta outline-cta--medium outline-cta--button-primary"
        @click="${this.toggleFilterVisibility}"
      >
        ${this.filtersVisible ? 'Close' : 'Filter'}
        <outline-icon
          library="legacy"
          size="1.5rem"
          name="${this.filtersVisible ? 'close' : 'filter'}"
        ></outline-icon>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-kyruus-facet-wrapper': OutlineKyruusFacetWrapper;
  }
}
